import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';
import notifier from '../helpers/notifier.js';

export default {
  namespaced: true,

  state: () => ({
    stats: {
      revenue: {
        total: 0,
        count: 0,
        average: 0,
      },
      weighted: {
        total: 0,
        average: 0,
      },
      open: {
        total: 0,
        count: 0,
        average: 0,
      },
      won: {
        total: 0,
        count: 0,
        average: 0,
      },
      age: {
        days: 0,
      },
    },
    stageClasses: {
      prospecting: 'badge-dark-grey',
      meetings: 'badge-orange',
      proposal: 'badge-teal',
      reporting: 'badge-blue',
      won: 'badge-green',
      lost: 'badge-red',
    },
    api: '',
    deal: null,
    deals: [],
    stage_groups: [
      { value: 'all', text: 'All', icon: 'check_circle_outline', color: 'text-black' },
      // Temp disabling prospecting stage: SM-6333
      // { value: 'prospecting', text: 'Prospecting', icon: 'visibility', color: '' },
      { value: 'meetings', text: 'Meetings', icon: 'question_answer', color: 'text-orange' },
      { value: 'reporting', text: 'Reporting', icon: 'equalizer', color: 'text-blue' },
      { value: 'proposal', text: 'Proposal', icon: 'handshake', color: 'text-teal' },
      { value: 'won', text: 'Won', icon: 'emoji_events', color: 'text-green' },
      { value: 'lost', text: 'Lost', icon: 'cancel_presentation', color: 'text-red' },
    ],
    filters: {
      stage_group: 'all',
      partner: null,
      per_page: 10,
      current_page: 1,
      page: null,
      sort_direction: null,
      sort_by: null,
      search: null,
    },
    pagination: {
      page: 1,
      per_page: 10,
      current_page: 1,
      total: 0,
      from: null,
      to: null,
    },
    loading: {
      deals: false,
      summary: false,
    },
  }),

  actions: {
    resetFiltersAndPagination({ commit }) {
      commit('setFilters', { key: 'stage_group', value: 'all' });
      commit('resetPagination');
    },

    getDealSummary: async ({ commit, state }) => {
      const partner = state.filters.partner;
      const url = `/partners/${partner}/deals/summary`;

      if (!partner) {
        return null;
      }

      commit('setLoading', { key: 'summary', value: true });

      await axios.get(url, { params: state.filters })
        .then(({ data }) => {
          Object.entries(data).forEach(([key, value]) => {
            commit('setStats', { key, value });
          })
        })
        .finally(() => {
          commit('setLoading', { key: 'summary', value: false });
        });
    },
    getDeals: async ({ commit, state }) => {
      const partner = state.filters.partner;
      const url = `/partners/${partner}/deals`;

      if (!partner) {
        return null;
      }

      commit('setLoading', { key: 'deals', value: true });

      await axios.get(url, { params: state.filters })
        .then(({ data }) => {
          commit('setDeals', { deals: data.data });

          commit('setPagination', { key: 'per_page', value: data.per_page });
          commit('setPagination', { key: 'page', value: data.page });
          commit('setPagination', { key: 'total', value: data.total });
          commit('setPagination', { key: 'current_page', value: data.current_page });
          commit('setPagination', { key: 'from', value: data.from });
          commit('setPagination', { key: 'to', value: data.to });

          commit('setFilters', { key: 'per_page', value: data.per_page });
        }).catch((error) => {
          commit('setDeals', { deals: [] });
          Object.keys(state.stats).forEach((type) => {
            Object.keys(state.stats[type]).forEach((key) => {
              commit('setStats', { key, value: 0, type });
            });
          });

          const errors = error.response.data.errors;
          Object.values(errors).forEach(value => notifier.failed(value));
        })
        .finally(() => {
          commit('setLoading', { key: 'deals', value: false });
        });
    },

  },

  mutations: {
    setDeal: (state, deal) => state.deal = deal,
    setDeals: (state, { deals }) => state.deals = deals,
    setStats: (state, { key, value, type = null }) => {
      if (type in state.stats && key in state.stats[type]) {
        state.stats[type][key] = value;
      } else if (key in state.stats) {
        state.stats[key] = value;
      }
    },
    setPagination: (state, { key, value }) => state.pagination[key] = value,
    resetPagination: (state) => {
      state.pagination.page = 1;
      state.pagination.per_page = 10;
      state.pagination.current_page = 1;
      state.pagination.total = 0;
      state.pagination.from = null;
      state.pagination.to = null;
    },

    setFilters: (state, { key, value }) => state.filters[key] = value,
    setPartner: (state, { partner }) => state.partner = partner,
    setLoading: (state, { key, value }) => state.loading[key] = value,
    updateField,
  },
  getters: {
    deal: ({ deal }) => deal,
    deals: ({ deals }) => deals,
    filters: ({ filters }) => filters,
    pagination: ({ pagination }) => pagination,
    stageClasses: ({ stageClasses }) => stageClasses,
    loading: ({ loading }) => loading,
    getField,
  },
};
